import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface SeoData {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
}

@Injectable({ providedIn: 'root' })
export class SeoService {
  private readonly defaults: Required<SeoData> = {
    title: 'Niterra México | NGK y NTK',
    description: 'Sitio oficial de Niterra México (NGK y NTK). Productos, soporte técnico, programas de marketing y más.',
    keywords: 'NGK, NTK, Niterra, México, bujías, sensores, autopartes, automotriz',
    image: '/assets/favicon/android-chrome-192x192.png'
  };

  constructor(private titleSrv: Title, private meta: Meta) {}

  apply(seo?: SeoData): void {
    const data = { ...this.defaults, ...(seo || {}) };

    this.titleSrv.setTitle(data.title);
    this.meta.updateTag({ name: 'title', content: data.title });
    this.meta.updateTag({ name: 'description', content: data.description });
    this.meta.updateTag({ name: 'keywords', content: data.keywords });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: data.title });
    this.meta.updateTag({ property: 'og:description', content: data.description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: data.image });
  }
}
